import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import 'vxe-table/lib/style.css'

Vue.use(ElementUI, { size: "small" });
